const prefix = '/onlinecs/knowledgeReview'

/**
 * 获取场景列表
 * @type {string}
 */
export const querySceneListUrl = `${prefix}/querySceneList`

/**
 * 获取LLM审核列表
 * @type {string}
 */
export const queryKnowledgeReviewPageUrl = `${prefix}/queryKnowledgeReviewPage`

/**
 * 修改审核状态
 * @type {string}
 */
export const modifyKnowledgeReviewStatusUrl = `${prefix}/modifyKnowledgeReviewStatus`

/**
 * 导出LLM审核列表
 * @type {string}
 */
export const downloadKnowledgeReviewUrl = `${prefix}/downloadKnowledgeReview`

/**
 * 批量删除LLM审核
 * @type {string}
 */
export const batchRemoveKnowledgeReviewUrl = `${prefix}/batchRemoveKnowledgeReview`

/**
 * 获取LLM审核详情
 * @type {string}
 */
export const getLCheckDetailUrl = `${prefix}/getLCheckDetail`

/**
 * 获取恩达审核的对话
 * @type {string}
 */
export const queryChatRecordListByKnowledgeReviewUrl = `${prefix}/queryChatRecordListByKnowledgeReview`